<template>
  <div class="flex justify-end gap-2 py-4">
    <Button
      :label="cancelLabel"
      severity="secondary"
      text
      @click="$emit('cancelClick')"
    />
    <Button
      :label="approveLabel"
      rounded
      :loading="approveLoading"
      :disabled="approveDisable || approveLoading"
      @click="$emit('approveClick')"
    />
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import { useSharedStore } from '@torim-app/shared-components';

defineProps({
  approveLabel: {
    type: String,
    required: false,
    default: 'שמירה'
  },
  cancelLabel: {
    type: String,
    required: false,
    default: 'ביטול'
  },
  approveDisable: {
    type: Boolean,
    required: false,
    default: false
  },
  approveLoading: {
    type: Boolean,
    required: false,
    default: false
  },
});

defineEmits(['cancelClick', 'approveClick']);

const sharedStore = useSharedStore();
const paddingBottom = computed(() => {
  return sharedStore.bottomPadding;
})
</script>
